/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Memberships. List of memberships.
 */
export interface MembershipParam { 
    /**
     * Id Hash. UUI (Unique User Identifier). Mandatory in the POST and PUT CompanyServices, Optional in the GET CompanyServices. Must not be specified in the POST, PUT and GET UserServices.
     */
    userIdHash?: string;
    /**
     * Id Hash. UCI (Unique Company Identifier). Mandatory in the POST and PUT UserServices, Optional in the GET UserServices. Must not be specified in the POST, PUT and GET CompanyServices.
     */
    companyIdHash?: string;
    /**
     * Company department name.
     */
    companyDepartmentName?: string;
    /**
     * Date Not Before. Format yyyy-MM-dd HH:mm:ss
     */
    notBefore?: string;
    /**
     * Date Not After. Format yyyy-MM-dd HH:mm:ss
     */
    notAfter?: string;
    /**
     * User role in this company. Maximum lenght 25
     */
    role?: string;
    /**
     * User membership number in this company. Maximum lenght 50
     */
    membershipNumber?: string;
    /**
     * User membership type in this company. Maximum lenght 50
     */
    membershipType?: string;
    /**
     * User membership QR or Barcode in this company, it\'s an image, encoded in Base64 format. Maximum lenght 2MB
     */
    membershipQR?: MembershipParam.MembershipQREnum;
}
export namespace MembershipParam {
    export type MembershipQREnum = '[B@6428591a';
    export const MembershipQREnum = {
        B6428591a: '[B@6428591a' as MembershipQREnum
    };
}


